exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.payment-page.bank_transfer[data-v-1d761ee6] {\n  padding-bottom: 152px;\n}\nbutton[data-v-1d761ee6] {\n  width: 100%;\n}\n.empty-cart[data-v-1d761ee6] {\n  padding: 15px;\n}\n.txt-normal[data-v-1d761ee6] {\n  font-size: 20px;\n  font-weight: 300;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d761ee6","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Payment.vue
// module id = 571
// module chunks = 1